var map = {
	"./CC_RecallDatabase.TShare.jpg": 1970,
	"./Database-CalloutShare-FB.jpg": 5801,
	"./Database-CalloutShare-Twitter.jpg": 5925,
	"./Database-FB-Final.png": 6291,
	"./Database-GIF-Pacemaker2.gif": 4824,
	"./Database-Map-FB.jpg": 9504,
	"./Database-Map-Twitter.jpg": 1102,
	"./icij-black@2x.png": 9278,
	"./icij-white.png": 94,
	"./icij-white.svg": 1361,
	"./icij-white@2x.png": 1298,
	"./icij.png": 5870,
	"./icij@2x.png": 7124,
	"./imddb-oval.jpg": 5273,
	"./imddb-transparent.jpg": 4768,
	"./sketch-a.png": 4342,
	"./sketch-b.jpg": 8072,
	"./sketch-c.png": 8898,
	"./sketch-d.jpg": 3420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6770;